import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { formatDate } from '@angular/common';
import Swal from 'sweetalert2';
import { LocalStorageService } from 'ngx-webstorage';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';       /// Change Language
import { Router } from '@angular/router';
import { LkpStoresModel } from 'src/app/models/LkpStoresModel';
import { LkpStoresService } from 'src/app/services/LkpStoresService';
import { RoomsModel } from 'src/app/models/RoomsModel';
import { RoomsService } from 'src/app/services/RoomsService';
import { StockTrnDetModel, StockTrnHDModel } from 'src/app/models/StockTrnModel';
import { StockTrnService } from 'src/app/services/StockTrnService';
import { DataBankService } from 'src/app/services/DataBankService';
import { DatabankModel } from 'src/app/models/DataBankModel';
import { InvoiceSearchComponent } from '../invoice-search/invoice-search.component';
import { PopuppatientsearchComponent } from '../popuppatientsearch/popuppatientsearch.component';
import { AccInvoiceEditComponent } from '../acc-invoice-edit/acc-invoice-edit.component';
import { CodessearchComponent } from '../codessearch/codessearch.component';
import { SuppliesModel } from 'src/app/models/SuppliesModel';
import { SuppliesService } from 'src/app/services/SuppliesService';


@Component({
  selector: 'app-stock-transaction',
  templateUrl: './stock-transaction.component.html',
  styleUrls: ['./stock-transaction.component.css']
})
export class StockTransactionComponent implements OnInit {
  hedtype = '' ;
  hedserial = 0 ;
  heddate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  hedsup_client = '' ;
  patientName = '';
  hedroomnumber = '' ;
  hedprogramno = '' ;
  hedtax1 = '' ;
  hedtax2 = '' ;
  heddisc1 = 0 ;
  heddisc2 = 0 ;
  hedstore = '' ;
  hedtostore = '' ;
  heddoctor = '' ;
  heddescription = '' ;
  hedpost = '' ;
  compcode = '1' ;
  userid = '' ;
  modifieddate = formatDate(new Date(), 'yyyy-MM-dd', 'en');

  dettype = '' ;
  detserial = 0 ;
  detline = 0 ;
  detitem = '' ;
  detitemname = '' ;
  detqty = 0 ;
  detprice = 0 ;
  detvalue = 0 ;
  detdescription = '' ;

  storesList: LkpStoresModel[] = [];
  roomsList: RoomsModel[] = [];
  stocktrndetList: StockTrnDetModel[] = [];
  Wk_total = 0;
  Wk_Net_Value = 0;
  Wk_Last_Serial = 0;
  wk_Title = '';
  wk_Customer_Supplier = '';
  constructor( public storage: LocalStorageService,
    private dialogref: MatDialog,
    public translate: TranslateService,
    public route: Router,
    public storesservice : LkpStoresService,
    public roomsService :RoomsService,
    public stocktrnhdservicse : StockTrnService,
    public dataBankService : DataBankService,
    public stocktrnhd : StockTrnHDModel,
    public patientsSelectedData : DatabankModel,
    public suppSelectedData : SuppliesModel,
    public suppliesService : SuppliesService) { }

    ngOnInit(): void {
      this.hedtype = this.storage.retrieve('stgtype');
      this.dettype = this.storage.retrieve('stgtype');

      if( this.storage.retrieve('stgtype') == '11')
      {
        this.wk_Title = 'إستلام بضاعة'
        this.wk_Customer_Supplier = 'Supplier'
      }
      if( this.storage.retrieve('stgtype') == '12')
      {
        this.wk_Title = 'مرتجعات الى المخزن';
        this.wk_Customer_Supplier = 'Patient'
      }
      if( this.storage.retrieve('stgtype') == '13'){ this.wk_Title = 'تسوية إضافة'}
      if( this.storage.retrieve('stgtype') == '20')
      {
        this.wk_Title = 'صرف من المخزن'
        this.wk_Customer_Supplier = 'Patient'
      }
      if( this.storage.retrieve('stgtype') == '22')
      {
         this.wk_Title = 'مرتجع للمورد'
         this.wk_Customer_Supplier = 'Supplier'
        }
      if( this.storage.retrieve('stgtype') == '23'){ this.wk_Title = 'تسوية خصم'}

      this.retriveNextSerial();
      this.retriveRoomsLookupTop();
      this.retriveStoresLookupTop();

      this.translate.use('ar');
      document.documentElement.dir = "rtl";
    }
    retriveNextSerial() {
      this.stocktrnhdservicse.GetStockTrnHdSerial(this.hedtype, this.storage.retrieve('stgcompCode')).subscribe((
        data: StockTrnHDModel) => {
        this.hedserial = data.hedserial + 1;
      });

    }
    retriveStoresLookupTop() {
      this.storesList = [];
      this.storesservice.LkpStoresLookupTop(this.storage.retrieve('stgcompCode')).subscribe((data: LkpStoresModel[]) => {
        for (let i = 0; i < data.length; i++) {
           this.storesList[i] = data[i];
           this.hedstore = data[i].strcode;
        }

      })
    }
    retriveRoomsLookupTop() {
      this.roomsService
        .getRoomsLookupTop(this.storage.retrieve('stgcompCode'))
        .subscribe((data: RoomsModel[]) => {
          for (let i = 0; i < data.length; i++) {
            this.roomsList[i] = data[i];
          }
          console.log(data);
        });
    }

    switchArabic(){
      this.translate.use('ar');
      document.documentElement.dir = "rtl";
    }
    switchEnglish(){
      this.translate.use('en');
      document.documentElement.dir = "ltr";
    }

    retriveStockHd() {

      this.stocktrnhdservicse.GetStockTrnHD(this.hedtype, this.hedserial.toString(), this.storage.retrieve('stgcompCode')).subscribe(
        (data: StockTrnHDModel) => {

          this.heddate =  formatDate(data.heddate, 'yyyy-MM-dd', 'en');
          this.hedsup_client = data.hedsup_client;
        
          this.RetrivePatient();

          this.hedtostore = data.hedtostore;
          this.hedroomnumber = data.hedroomnumber;
          this.hedprogramno = data.hedprogramno;

          this.hedtax1 = data.hedtax1;
          this.hedtax2 = data.hedtax2;
          this.heddisc1 = data.heddisc1;
          this.heddisc2 = data.heddisc2;
          this.hedstore = data.hedstore;
          this.hedtostore= data.hedtostore;
          this.heddescription = data.heddescription;

          this.retriveStockTrnDet();

        }
      );
    }
    retriveStockTrnDet() {
      this.stocktrndetList = [];
      this. Wk_total =0;
      this.stocktrnhdservicse.GetStockTrnDet(this.hedtype, this.hedserial.toString(), this.storage.retrieve('stgcompCode')).subscribe((data: StockTrnDetModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.stocktrndetList[i] = data[i];
          this.stocktrndetList[i].detitemname = data[i].detitemname;
          this. Wk_total =this. Wk_total  +  data[i].detvalue;
          this.Wk_Last_Serial = data[i].detline;
        }
        this.Wk_Net_Value =  this. Wk_total  - this.heddisc1;
      })

    }
    openDialogSerial(){
      const dialogRef = this.dialogref.open(InvoiceSearchComponent,
        {
          data: {
            dataKey: this.stocktrnhd,
            hedtype : this.hedtype
          }
      });
      dialogRef.afterClosed().subscribe(result => {
      });

      const dialogSubmitSubscription =
         dialogRef.componentInstance.submitClicked.subscribe(result => {
          this.hedserial = result.hedserial;

          this.retriveStockHd();
          dialogSubmitSubscription.unsubscribe();

        });
    }

    openDialogPatient(){
      if ( this.hedtype == '12' || this.hedtype == '20' ){
      const dialogRef = this.dialogref.open(PopuppatientsearchComponent, {
        data: {
          dataKey: this.patientsSelectedData,
        },
      });
      dialogRef.afterClosed().subscribe((result) => {});
      const dialogSubmitSubscription =
        dialogRef.componentInstance.submitClicked.subscribe((result) => {
          this.hedsup_client = result.patientCode;
          this.RetrivePatient();

          dialogSubmitSubscription.unsubscribe();

        });
      }
      if ( this.hedtype == '11' || this.hedtype == '22' ){
        const dialogRef = this.dialogref.open(CodessearchComponent,
          {
            data: {
              dataKey: this.suppSelectedData
            }
        });
        dialogRef.afterClosed().subscribe(result => {
        });

        const dialogSubmitSubscription =
           dialogRef.componentInstance.submitClicked.subscribe(result => {
            this.hedsup_client = result.supCode;
            this.patientName = result.supName;
            dialogSubmitSubscription.unsubscribe();

          });

        }

    }

    submitInvoice(){
      if (this.hedserial == 0 || this.hedserial == null) {
        return;
      }

      this.stocktrnhd.hedtype = this.hedtype;
      this.stocktrnhd.hedserial = this.hedserial;
      this.stocktrnhd.heddate = formatDate(this.heddate, 'yyyy-MM-dd', 'en');
      this.stocktrnhd.hedsup_client = this.hedsup_client;
      this.stocktrnhd.hedroomnumber = this.hedroomnumber;
      this.stocktrnhd.hedprogramno = this.hedprogramno;
      this.stocktrnhd.hedstore = this.hedstore;
      this.stocktrnhd.hedtostore = this.hedtostore;
      this.stocktrnhd.hedtax1 = this.hedtax1;
      this.stocktrnhd.hedtax2 = this.hedtax2;
      this.stocktrnhd.heddisc1 = this.heddisc1;
      this.stocktrnhd.heddisc2 = this.heddisc2;
      this.stocktrnhd.heddescription = this.heddescription;
      this.stocktrnhd.hedpost = this.hedpost;

      this.stocktrnhd.userid = this.storage.retrieve('stguserId');
      this.stocktrnhd.modifieddate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
      this.stocktrnhd.compcode = this.storage.retrieve('stgcompcode');


      this.stocktrnhdservicse.AddStockTrnHD(this.stocktrnhd).subscribe(data => {
      },
        error => { alert(error); }
      );
    }
    DeleteInvoice(){
      this.stocktrnhdservicse.DelStockTrnHD(this.hedtype, this.hedserial.toString(), this.storage.retrieve('stgcompCode')).subscribe(
        (data: StockTrnHDModel) => {
        }
      );

      this.stocktrnhdservicse.DelStockTrnDet(this.hedtype, this.hedserial.toString(), this.storage.retrieve('stgcompCode')).subscribe(
        (data: StockTrnDetModel) => {
        }
      );
      this.NewData();

    }
    MesgDelete(){
        Swal({
          title: 'Are you sure?',
          text: 'You will not be able to recover this record!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete it!',
          cancelButtonText: 'No, keep it',
        }).then(
          () => {
            this.DeleteInvoice();
            Swal('Deleted!', 'Your record has been deleted.', 'success');
          },
          function (dismiss) {
            if (dismiss === 'cancel') {
              Swal('Cancelled', 'Your record is safe :)', 'error');
            }
          }
        );


    }
    NewData(){
        this.hedtype = '21' ;
        this.hedserial = 0 ;
        this.heddate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
        this.hedsup_client = '' ;
        this.patientName = '';
        this.hedroomnumber = '' ;
        this.hedprogramno = '' ;
        this.hedtax1 = '' ;
        this.hedtax2 = '' ;
        this.heddisc1 = 0 ;
        this.heddisc2 = 0 ;
        this.hedstore = '' ;
        this.hedtostore = '' ;
        this.heddoctor = '' ;
        this.heddescription = '' ;
        this.hedpost = '' ;

        this.dettype = '21' ;
        this.detserial = 0 ;
        this.detline = 0 ;
        this.detitem = '' ;
        this.detitemname = '' ;
        this.detqty = 0 ;
        this.detprice = 0 ;
        this.detvalue = 0 ;
        this.detdescription = '' ;
        this.stocktrndetList = [];
        this. Wk_Net_Value = 0;
        this.Wk_total = 0;
        this.Wk_Last_Serial = 0;
        this.retriveNextSerial();
    }
    ReportInvoice(){}

    RetrivePatient(){
      if ( this.hedtype == '12' || this.hedtype == '20'  || this.hedtype == '21'){
      this.dataBankService.getPatient(this.hedsup_client,this.storage.retrieve('stgcompCode')).subscribe((data: DatabankModel) => {
        this.patientName = data.patientFName;
      })
    }
    if ( this.hedtype == '11' || this.hedtype == '22'  ){
      this.suppliesService.getsupplies(this.hedsup_client,this.storage.retrieve('stgcompCode')).subscribe((data : SuppliesModel) => {
        this.patientName = data.supName;

      })
    }

    }
    SelectLine(pro : StockTrnDetModel){
      this.submitInvoice();
      const dialogRef = this.dialogref.open(AccInvoiceEditComponent,
          {
            data: {
              dataKey: this.stocktrndetList,
              dettype : this.hedtype,
              detserial: this.hedserial,
              detline: pro.detline,
              detitem: pro.detitem,
              detitemname: pro.detitemname,
              detqty: pro.detqty,
              detprice: pro.detprice,
              detvalue: pro.detvalue,
              detdescription: pro.detdescription

            },
            width: '70vw',

          });
        dialogRef.afterClosed().subscribe(result => {
          this.retriveStockTrnDet();
        });
        this.retriveStockTrnDet();
    }
    New_Line(){
      this.submitInvoice();
      const dialogRef = this.dialogref.open(AccInvoiceEditComponent,
          {
            data: {
              dataKey: this.stocktrndetList,
              dettype : this.hedtype,
              detserial: this.hedserial,
              detline: this.Wk_Last_Serial + 1,
              detitem: '',
              detitemname: '',
              detqty: 0,
              detprice: 0,
              detvalue: 0,
              detdescription: ''

            },
            width: '70vw',

          });
        dialogRef.afterClosed().subscribe(result => {
          this.retriveStockTrnDet();
        });
        this.retriveStockTrnDet();
    }
    ClucDiscPer(){
      this.Wk_Net_Value =  this. Wk_total  - this.heddisc1;
    }
    mesgSave() {
      Swal({
        title: 'Your work has been saved',
        type: 'success',
        showConfirmButton: false,

        timer: 1500,
      });
    }

}
